import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=70b9ffe9&"
import script from "./Agent.vue?vue&type=script&lang=ts&"
export * from "./Agent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports